import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import styled, { createGlobalStyle } from "styled-components"
import P from '../pages';
import { useSelector, useDispatch } from 'react-redux';
import Redirector from './ui/Redirector';
import GoogleMapsAddress from './ui/GoogleMapsAddress';
import FormHeader from './ui/FormHeader';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col'
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import Styles from "../../../shared/components/styled/Address.styles"
import { setAddress as setAddressAction } from '../actions'
import { defaultMessages } from '../../../libs/i18n/default';
import { injectIntl } from 'react-intl';

const GlobalStyle = createGlobalStyle`
  @media (min-width: 768px) {
    #host_signup>.container {
      width: 600px;
    }
    #host_signup>.container>.panel {
      border-radius: 12px;
    }
  }
`

const GoogleSearch = styled(GoogleMapsAddress)`
  & .form-control {
    margin-bottom: 3rem;
    padding: 1rem 1.8rem;
    height: 100%;
    border-color: #AFBBC4;
    &::placeholder {
      color: #AFBBC4;
    }
  }
`

const Address = ({ intl }) => {
  const dispatch = useDispatch()
  const page = useSelector(state => state.page)
  const {
    address_redirect_url: redirectUrl,
    country_code: countryCode,
    transaction_email: transactionEmail,
    code,
    address_logo_srsc,
    address_logo_usa,
  } = useSelector(state => state.territory)
  const [address, setAddress] = useState({})

  const updateAddressState = (key, value) => {
    // Have to use the spread operator here to create a new object rather
    // than a copy of the existing object.  Reference must change in order
    // for react to re-render
    let newAddress = { ...address }
    newAddress[key] = value
    setAddress(newAddress)
  }

  const pageValid = () => {
    return(address.place_id ? true : false)
  }

  const submit = () => {
    let params = new URLSearchParams(window.location.search)
    params.append('place_id', address.place_id)
    let californiaAddress = address.state == 'CA' || address.state == 'California'
    let redirect = (
      (californiaAddress && code != 'SRSC') ||
      (!californiaAddress && code == 'SRSC')
    )
    if (!redirect) {
      dispatch(setAddressAction(address))
    } else {
      let uri = `${redirectUrl}/hosts/signup${params.toString() && `?${params.toString()}`}`
      window.location = encodeURI(uri)
    }
  }



  return (
    <Styles.AddressContainer>
      <GlobalStyle />
      <Redirector this_page={P.ADDRESS_PAGE} page={page}/>
      <Styles.Row>
        <Col lg={11}>
          <div className="text-center">
            <Styles.Logo src={address_logo_srsc} alt="StudentRoomStayConcierge Logo" />
            <Styles.Logo src={address_logo_usa} alt="AHN USA Logo" />
          </div>
          <Styles.Title>{intl.formatMessage(defaultMessages.clientHostPagesAddressTitle)}</Styles.Title>
          <Styles.SubTitle>{intl.formatMessage(defaultMessages.clientHostPagesAddressSubtitle)}</Styles.SubTitle>
          <Styles.Seperator />
          <Styles.Help>{intl.formatMessage(defaultMessages.clientHostPagesAddressHelptext)}</Styles.Help>
          <FormGroup>
            <GoogleSearch
            updateAddress={updateAddressState}
            countryCode={countryCode}
            formatMessage={intl.formatMessage} />
          </FormGroup>
        <Styles.Submit
          disabled={!pageValid()}
          onClick={submit}>Continue</Styles.Submit>
        </Col>
      </Styles.Row>
    </Styles.AddressContainer>
  )
}

export default injectIntl(Address)
